import { COOKIE_DOMAIN, LOGIN_TYPE_KEY } from '@/data/siteConfig';

// ========== 跨站共享凭证（token / corporate / loginType）==========
// cookie 的作用域不含端口（RFC 6265）：生产环境写 .teguitong.com 跨子域共享；
// 本地与内网 IP 环境（COOKIE_DOMAIN 为空）写 host-only cookie，同一 host 的多个端口
// （如 192.168.2.5:8080/8081/8082）同样共享。三站因此永远读到同一份最新凭证，
// 不会出现某一站揣着本站 localStorage 里的旧 token 调接口 401 → 触发「退出中」全局登出
const COOKIE_ATTRS = COOKIE_DOMAIN ? `domain=${COOKIE_DOMAIN}; path=/; secure` : 'path=/';
const COOKIE_MAX_AGE = 7 * 24 * 60 * 60;

// 写共享凭证（cookie + 本站 localStorage 双写）
function setShareCookie(name, value) {
	try {
		document.cookie = `${name}=${encodeURIComponent(value)}; ${COOKIE_ATTRS}; max-age=${COOKIE_MAX_AGE}`;
	} catch (e) {
		console.log(`[共享cookie-${name}] 写入异常`, e);
	}
}

// 读共享凭证：一律以 cookie 为准，读到则同步回本站 localStorage；
// cookie 不存在时清掉本站 localStorage 残留——各端口 localStorage 互相独立，残留正是旧凭证的来源
function getShareCookie(name) {
	let value = '';
	try {
		const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
		value = match && match[1] ? decodeURIComponent(match[1]) : '';
	} catch (e) {
		console.log(`[共享cookie-${name}] 读取失败`, e);
	}
	try {
		if (value) {
			localStorage.setItem(name, value);
		} else {
			localStorage.removeItem(name);
		}
	} catch (e) {
		/* ignore */
	}
	return value || null;
}

// 清除共享凭证：host-only cookie 与带 domain 的 cookie 互不覆盖，两种作用域各清一次
function removeShareCookie(name) {
	try {
		document.cookie = `${name}=; path=/; max-age=0`;
		if (COOKIE_DOMAIN) {
			document.cookie = `${name}=; ${COOKIE_ATTRS}; max-age=0`;
		}
	} catch (e) {
		/* ignore */
	}
}

const User = {
	// 存储当前登录用户的信息
	setUserInfo(uinfo) {
		let str = JSON.stringify(uinfo);
		localStorage.setItem('userinfo', str);
	},

	// 获取登录用户信息
	getUserInfo() {
		let str = localStorage.getItem('userinfo');
		let uinfo = JSON.parse(str);
		if (!uinfo || !uinfo.id || uinfo.id <= 0) {
			uinfo = { user_id: 0 };
		}
		return uinfo;
	},


	// 存储企业信息
	setCorporateList(cList) {
		let str = JSON.stringify(cList);
		localStorage.setItem('corporateList', str);
	},

	// 获取企业信息
	getCorporateList() {
		let str = localStorage.getItem('corporateList');
		let cList = JSON.parse(str);
		return cList;
	},

	// 存储当前登录企业信息索引（localStorage + 共享 cookie 双写）
	setCorporate(cinfo) {
		let str = JSON.stringify(cinfo);
		localStorage.setItem('corporate', str);
		setShareCookie('corporate', str);
	},

	// 获取当前登录企业信息索引（共享 cookie 优先，保证三站看到的是同一家企业）
	getCorporate() {
		const str = getShareCookie('corporate');
		if (!str) return null;
		try {
			return JSON.parse(str);
		} catch (e) {
			console.log('[共享cookie-corporate] 解析失败', e);
			return null;
		}
	},

	// 判断是否登录
	isLogin() {
		const tk = this.getToken();
		return !!tk;
	},

	// 存储token（localStorage + 共享 cookie 双写）
	setToken(token) {
		localStorage.setItem('token', token);
		setShareCookie('token', token);
	},

	// 获取token（共享 cookie 优先，退出登录在同一作用域内全局生效）
	getToken() {
		return getShareCookie('token');
	},

	// 退出登录
	logout() {
		this.removeUserInfo();
		this.removeToken();
		this.removeCorporateInfo();
		this.removeCorporate();
		this.removeLoginType();
	},

	// 移除token（同时清除 localStorage 和共享 cookie）
	removeToken() {
		localStorage.removeItem('token');
		removeShareCookie('token');
	},

	// 移除用户信息
	removeUserInfo() {
		localStorage.removeItem('userinfo');
	},

	// 移除企业信息
	removeCorporateInfo() {
		localStorage.removeItem('corporateList');
	},

	// 移除索引（同时清除 localStorage 和共享 cookie）
	removeCorporate() {
		localStorage.removeItem('corporate');
		removeShareCookie('corporate');
	},

	// ========== 登录类型（区分个人/企业） ==========

	// 存储登录类型（localStorage + 共享 cookie 双写）
	setLoginType(type) {
		localStorage.setItem(LOGIN_TYPE_KEY, type);
		setShareCookie(LOGIN_TYPE_KEY, type);
	},

	// 获取登录类型（共享 cookie 优先）
	getLoginType() {
		return getShareCookie(LOGIN_TYPE_KEY);
	},

	// 移除登录类型（同时清除 localStorage 和共享 cookie）
	removeLoginType() {
		localStorage.removeItem(LOGIN_TYPE_KEY);
		removeShareCookie(LOGIN_TYPE_KEY);
	},
};

export default User;
